// Lightweight singleton exposing the currently-loaded members list keyed by
// memberId. Populated by KingdomConnect after it fetches /api/members and kept
// in sync when members are added/edited. Consumed by cross-cutting UI (Avatar
// ring resolution) so no component has to prop-drill member status.

let _byId = new Map();
let _byName = new Map();
const _subs = new Set();

function normalizeName(s) {
  return String(s || "").trim().toLowerCase();
}

export function setMembers(list) {
  _byId = new Map();
  _byName = new Map();
  (list || []).forEach(m => {
    if (!m) return;
    if (m.id) _byId.set(m.id, m);
    const fullName = `${m.firstName || ""} ${m.lastName || ""}`.trim();
    if (fullName) _byName.set(normalizeName(fullName), m);
  });
  _subs.forEach(fn => { try { fn(); } catch (_) { /* ignore */ } });
}

export function getMemberById(id) {
  if (!id) return null;
  return _byId.get(id) || null;
}

export function getMemberByName(name) {
  return _byName.get(normalizeName(name)) || null;
}

export function getMemberStatus({ memberId, name } = {}) {
  const m = (memberId && _byId.get(memberId)) || (name && _byName.get(normalizeName(name))) || null;
  return m?.memberStatus || null;
}

export function subscribeMembers(fn) {
  _subs.add(fn);
  return () => _subs.delete(fn);
}
